import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  admin: null,
  token: localStorage.getItem("token") || null,
  refreshToken: localStorage.getItem("refreshToken") || null,
  isAuthenticated: !!localStorage.getItem("token"),
  loading: false,
  error: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    authStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    authSuccess: (state, action) => {
      state.loading = false;
      state.admin = action.payload.admin;
      state.token = action.payload.token;
      state.refreshToken = action.payload.refreshToken;
      state.isAuthenticated = true;
      state.error = null;

      // Save to localStorage
      localStorage.setItem("token", action.payload.token);
      localStorage.setItem("refreshToken", action.payload.refreshToken);
    },
    authFail: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    getCurrentAdmin: (state, action) => {
      state.loading = false;
    },
    logout: (state) => {
      state.admin = null;
      state.token = null;
      state.refreshToken = null;
      state.isAuthenticated = false;

      // Remove from localStorage
      localStorage.removeItem("token");
      localStorage.removeItem("refreshToken");
    },
    setAdmin: (state, action) => {
      state.admin = action.payload;
    },
    updateAdminProfile: (state, action) => {
      state.admin = { ...state.admin, ...action.payload };
    },
    clearError: (state) => {
      state.error = null;
    },
    refreshTokenSuccess: (state, action) => {
      state.token = action.payload.token;
      state.refreshToken = action.payload.refreshToken;

      // Update localStorage
      localStorage.setItem("token", action.payload.token);
      localStorage.setItem("refreshToken", action.payload.refreshToken);
    },
  },
});

export const {
  authStart,
  authSuccess,
  authFail,
  logout,
  setAdmin,
  updateAdminProfile,
  clearError,
  refreshTokenSuccess,
  getCurrentAdmin,
} = authSlice.actions;

export default authSlice.reducer;
